import {
  FLOOR_POOL,
  MAX_TIER,
  isBossTier,
  tierForDepth,
  type FloorNode,
} from "./floorPool";

export interface RunSnapshot {
  floorNumber: number;
  tier: number;
  path: string;
  nodeName: string;
}

export class RunManager {
  private readonly nodes: FloorNode[];
  private lastPath: string | null = null;

  constructor(nodes: FloorNode[] = FLOOR_POOL) {
    this.nodes = nodes;
  }

  tierForDepth(floorNumber: number): number {
    return tierForDepth(floorNumber);
  }

  pickFloor(floorNumber: number): RunSnapshot {
    const tier = tierForDepth(floorNumber);

    // Boss tier: single boss node (no immediate repeat concerns).
    if (tier === MAX_TIER || isBossTier(floorNumber)) {
      const boss = this.nodes.filter((n) => n.tier === MAX_TIER);
      const chosen = boss[Math.floor(Math.random() * boss.length)];
      if (!chosen) throw new Error("Boss tier floor pool is empty");
      this.lastPath = chosen.path;
      return snapshot(chosen, floorNumber, tier);
    }

    const candidates = this.nodes.filter(
      (n) => n.tier === tier && n.path !== this.lastPath
    );
    const pool =
      candidates.length > 0
        ? candidates
        : this.nodes.filter((n) => n.tier === tier);
    const chosen = pool[Math.floor(Math.random() * pool.length)];
    if (!chosen) throw new Error(`Floor pool is empty for tier ${tier}`);
    this.lastPath = chosen.path;
    return snapshot(chosen, floorNumber, tier);
  }

  setLastPath(path: string): void {
    this.lastPath = path;
  }
}

function snapshot(
  node: FloorNode,
  floorNumber: number,
  tier: number
): RunSnapshot {
  return {
    floorNumber,
    tier,
    path: node.path,
    nodeName: node.name,
  };
}
